<ng-container [ngSwitch]="state">
  <ng-container *ngSwitchCase="'success'">
    <div class="successBannerStructure">
      <span class="banner">{{ message }}</span>
      &nbsp;
      <span *ngIf="actionText" class="actionText" (click)="handleAction($event)">{{
        actionText
      }}</span>
    </div>
  </ng-container>

  <ng-container *ngSwitchCase="'info'">
    <div class="infoBannerStructure">
      <img src="/assets/fusus-icons/SVG/information-2-fill.svg" alt="info" />
      &nbsp;
      <span class="banner">{{ message }}</span>
    </div>
  </ng-container>

  <ng-container *ngSwitchCase="'warning'">
    <div class="warningBannerStructure">
      <img src="/assets/fusus-icons/SVG/alert-fill.svg" alt="warning" />
      &nbsp;
      <span class="banner">{{ message }}</span>
    </div>
  </ng-container>

  <ng-container *ngSwitchCase="'error'">
    <div class="errorBannerStructure">
      <img src="/assets/fusus-icons/SVG/alert-fill.svg" alt="error" />
      &nbsp;
      <span class="banner">{{ message }}</span>
    </div>
  </ng-container>
</ng-container>
